var _defs, _rect, _rect2, _path, _path2, _g, _g2, _rect3, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2B5876"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#2B5876; #4E4376; #2B5876",
    dur: "10s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4E4376"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#4E4376; #2B5876; #4E4376",
    dur: "10s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "particle-pattern",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 1,
    fill: "#FFD93D",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1;2;1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "wave-blur"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#hero-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#particle-pattern)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 300Q480 200 960 300T1920 300V1080H0V300Z",
    fill: "#2B5876",
    fillOpacity: 0.1,
    filter: "url(#wave-blur)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M0 300Q480 200 960 300T1920 300V1080H0V300Z;                      M0 300Q480 400 960 300T1920 300V1080H0V300Z;                      M0 300Q480 200 960 300T1920 300V1080H0V300Z",
    dur: "15s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 400Q480 300 960 400T1920 400V1080H0V400Z",
    fill: "#4E4376",
    fillOpacity: 0.1,
    filter: "url(#wave-blur)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M0 400Q480 300 960 400T1920 400V1080H0V400Z;                      M0 400Q480 500 960 400T1920 400V1080H0V400Z;                      M0 400Q480 300 960 400T1920 400V1080H0V400Z",
    dur: "10s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF6B6B",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "200;220;200",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1720,
    cy: 300,
    r: 150
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "300;280;300",
    dur: "5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 150,
    r: 80
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "150;170;150",
    dur: "3s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFD93D",
    fillOpacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L500 1080H0V0Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.05;0.1;0.05",
    dur: "5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1920 0L1420 1080H1920V0Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.05;0.1;0.05",
    dur: "5s",
    repeatCount: "indefinite"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#grid)",
    fillOpacity: 0.05
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 0 L 0 0 0 40",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.82007494e5175f07f99dd33076e123a1.svg";
export { ForwardRef as ReactComponent };